export default function sortInPossessionsTabOrder(items) {
  const canonicalOrder = [
    // Standard
    'Hat',
    'Clothing',
    'Gloves',
    'Weapon',
    'Boots',
    'Companion',
    'Destiny',
    // Expanded
    'Affiliation',
    'Transportation',
    'HomeComfort',
    'Ship',
    'Spouse', // ?????
    'Club',
  ];
  return [...items]
    .sort((a, b) => canonicalOrder.indexOf(a.category) - canonicalOrder.indexOf(b.category));
}